import { render, staticRenderFns } from "./ContentListPage.vue?vue&type=template&id=4bb81828&scoped=true"
import script from "./ContentListPage.vue?vue&type=script&lang=js"
export * from "./ContentListPage.vue?vue&type=script&lang=js"
import style0 from "./ContentListPage.vue?vue&type=style&index=0&id=4bb81828&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb81828",
  null
  
)

export default component.exports